// Data statis portfolio — personalInfo, aboutData, statsData
// Skills / Portfolio / Certifications diambil dari API MySQL

export const personalInfo = {
  name: "Erwin Paisal",
  title: "IT Professional",
  tagline: "Solusi teknologi terpercaya untuk bisnis dan individu di Medan, Indonesia.",
  location: "Medan, Sumatera Utara, Indonesia",
  email: "erwin@erwinpaisal.id",
  phone: "+62 812-3456-7890",
  whatsapp: "6281234567890",
  linkedin: "https://linkedin.com/in/erwinpaisal",
  domain: "erwinpaisal.id",
};

export const aboutData = {
  bio: [
    "Halo! Saya Erwin Paisal, seorang profesional IT berpengalaman yang berbasis di Medan, Sumatera Utara. Dengan lebih dari 5 tahun pengalaman di bidang teknologi informasi, saya telah membantu berbagai perusahaan dan individu menyelesaikan tantangan teknologi mereka.",
    "Saya memiliki keahlian mendalam di bidang perakitan dan troubleshooting hardware, instalasi dan konfigurasi software, serta setup jaringan dan routing. Pendekatan saya selalu berfokus pada solusi praktis yang tepat sasaran dan efisien.",
  ],
  experience: [
    {
      id: 1,
      role: "IT Support Specialist",
      company: "PT. Teknologi Maju Medan",
      period: "2021 – Sekarang",
      description: "Mengelola infrastruktur IT perusahaan, troubleshooting hardware dan software, serta konfigurasi jaringan LAN/WAN untuk 50+ pengguna.",
    },
    {
      id: 2,
      role: "Network Technician",
      company: "CV. Solusi Digital Nusantara",
      period: "2019 – 2021",
      description: "Instalasi dan konfigurasi perangkat jaringan (router, switch, access point), monitoring performa jaringan, dan pemeliharaan sistem secara berkala.",
    },
    {
      id: 3,
      role: "Teknisi Hardware",
      company: "Toko Komputer Mitra Jaya",
      period: "2017 – 2019",
      description: "Perakitan PC custom, perbaikan laptop dan komputer, upgrade komponen hardware, serta konsultasi pembelian perangkat untuk pelanggan.",
    },
  ],
};

export const statsData = [
  { label: "Tahun Pengalaman", value: "5+" },
  { label: "Proyek Selesai", value: "80+" },
  { label: "Klien Puas", value: "60+" },
  { label: "Sertifikasi IT", value: "6" },
];
